import React from 'react';
import { useLocation } from 'react-router-dom';

import { ROUTE_PATH } from 'app/lib/routing/constants';

import { ServiceMenu } from '../ServiceMenu';
import HomepageMenu from './submodules/HomepageMenu';
import LiveMenu from './submodules/LiveMenu';
import PrematchMenu from './submodules/PrematchMenu';

const LeftMenu: React.FC = () => {
  const { pathname } = useLocation();

  if (isHomepageMenu(pathname)) {
    return <HomepageMenu />;
  }

  if (pathname.startsWith(ROUTE_PATH.PREMATCH)) {
    return <PrematchMenu />;
  }

  if (pathname.startsWith(ROUTE_PATH.LIVE)) {
    return <LiveMenu />;
  }

  return <ServiceMenu />;
};

function isHomepageMenu(pathname: string) {
  return pathname === ROUTE_PATH.ROOT
    || pathname.startsWith(ROUTE_PATH.RESULTS)
    || pathname.startsWith(ROUTE_PATH.EXTERNAL_GAMES)
    || pathname.startsWith(ROUTE_PATH.PROMOTIONS);
}

export default LeftMenu;
